import { render, staticRenderFns } from "./tls_policy.vue?vue&type=template&id=3bd34a4c&scoped=true&"
import script from "./tls_policy.vue?vue&type=script&lang=js&"
export * from "./tls_policy.vue?vue&type=script&lang=js&"
import style0 from "./tls_policy.vue?vue&type=style&index=0&id=3bd34a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd34a4c",
  null
  
)

export default component.exports